export default __webpack_public_path__ + "static/media/tickA.34e41100.svg";